import React, { useMemo } from "react";

import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import {
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";

const MissionVisionPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);

  const {
    data: visionAndMissionData = [],
    isLoading: visionAndMissionIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "vision_mission",
    lang: languageType,
  });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(visionAndMissionData)?.changed
    );
  }, [visionAndMissionData]);

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Mission and Vision", "मिशन और विजन")}
        titleLink="/mission-vision"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Mission and Vision", "मिशन और विजन")}
      />

      <div className="inner-container">
        <div className="container about_inntxt">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="power-section">
              <div className="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
                  <div className="title-sec">
                    <h4 className="title-sec">{getText("Vision", "विजन")}</h4>
                    <p>
                      {getText(
                        "To be a leading integrated Electric Power Company of the country with a strong environment conscience.",
                        "मजबूत पर्यावरण चेतना के साथ देश की अग्रणी एकीकृत इलेक्ट्रिक पावर कंपनी बनना।"
                      )}
                    </p>
                  </div>
                  <div className="title-sec">
                    <h4 className="title-sec">{getText("Mission", "मिशन")}</h4>
                    <p>
                      {getText(
                        "To harness the huge power potential of the country, from conventional and non-conventional sources, with minimal impact on the environment through a planned development of power generation projects by an integrated approach covering all aspects of investigation, planning, design construction, operation and maintenance of power projects, which in turn would effectively promote the development of the nation as a  whole",
                        "जांच, योजना, डिजाइन निर्माण, संचालन और रखरखाव के सभी पहलुओं को कवर करते हुए एक एकीकृत दृष्टिकोण द्वारा बिजली उत्पादन परियोजनाओं के नियोजित विकास के माध्यम से पर्यावरण पर न्यूनतम प्रभाव के साथ पारंपरिक और गैर-पारंपरिक स्रोतों से देश की विशाल बिजली क्षमता का दोहन करना। बिजली परियोजनाओं की, जो बदले में समग्र रूप से राष्ट्र के विकास को प्रभावी ढंग से बढ़ावा देगी"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MissionVisionPage;
